import { useState } from 'react';
import '../../styles/Home.css';
import { useParams } from 'react-router-dom';
import flyerData from '../../data/flyerData.json';
import parse from 'html-react-parser';

const GalleryItem = () => {
  const { name } = useParams();

  console.log("Entered*****");
  var source = "/images/steam/results/" + name;
  console.log(name);
  var bld = "";



  if (name.includes(".mp3")) {
    bld = bld + "<p className=\"center-align rounded\"><audio controls><source src=\"/images/steam/results/" + name + "\" alt=\"\" type=\"audio/mp4\"></source></audio></p>";
  }
  else {
    bld = bld + "<p className=\"center-align rounded\"><img src=\"/images/steam/results/" + name + "\" alt=\"\" width=\"80%\" /></p>";
  }


  return (
    <div className="container">
      <div>
        <div>
          {parse(bld)}
        </div>
      </div>
    </div>
  );
}
export default GalleryItem;
